
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/new",
      function () {
        return require("private-next-pages/companies/new/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/new"])
      });
    }
  